<template>
  <div style="display:flex;justify-content:center;align-items:center;height:100vh;">
    <div v-if="error" style="text-align:center;">
      <p>{{ error }}</p>
      <el-button @click="$router.replace('/')">返回首页</el-button>
    </div>
    <div v-else style="text-align:center;">
      <p>正在确认支付，请稍候...</p>
      <i class="el-icon-loading" style="font-size:32px;"></i>
    </div>
  </div>
</template>

<script>
import { capturePaypal } from '@/api/order/payment.js'

export default {
  name: 'PaypalReturn',
  data() {
    return { error: null }
  },
  async mounted() {
    const token = this.$route.query.token
    const paymentLogSn = localStorage.getItem('paypalPaymentLogSn')
    const paypalOrderId = localStorage.getItem('paypalOrderId') || token

    if (!paymentLogSn || !paypalOrderId) {
      this.error = '支付信息缺失，请重新下单'
      return
    }

    try {
      await capturePaypal(paymentLogSn, paypalOrderId)
      localStorage.removeItem('paypalPaymentLogSn')
      localStorage.removeItem('paypalOrderId')
      this.$router.replace('/paySuccess')
    } catch (e) {
      this.error = e?.message || '支付确认失败，请联系客服'
    }
  },
}
</script>
